import { authHeader, history } from "../_helpers";
import { handleResponse } from "../_helpers/response";
import config from "../config";
import axios from "axios";

export const RoleByService = {
  OngoingPreventiveActionListByRole,
  CompletedPreventiveActionListByRole,
  getPreventiveListByRole,
  getPreventiveCountByRole,
  getOngoingPreventiveActionCountByRole,
  getCompletedPreventiveActionCountByRole,
  getAllCountByRole,
  getStatisticalReport,
  TotalAppUsersCountByRole,
  getArrestReportByRole,
  getReportSpotviseByRole,
  getGpsinformationByRole,
  getQrInformationByRole,
  getCriminalsTableInfoByRole,
  getCriminalsAppInfoSearchByrole,
  getGunaHeadingArophiFilterByRole,
  getCriminalsHeadingFilterByRole,
  getFilterCriminalsTableInfoByRole,
  gunaYearWiseByRole,
  totaltwoplusCountByRole,
  preventionActionCountByRole,
  surveillanceCountByRole,
  totalappuserCountByRole,
  filledPoliceStationDailyByRole,
  notFilledPoliceStationDailyByRole,
  getWantedCountByRole,
  getConditionWantedByRole,
  getTadipaarCountByRole,
  getTadipaarByRole,
  getListGunaReportByRole,
  getCountGunaReportByRole,
  gunaFilterDropDownByRole,
  noticeCountByRole,
  noticeListByRole,
  getArrestCountByRole,
  noticeGraphByRole,
  arrestGraphByRole,
  gunaGraphByRole,
  getPreventiveActionAnalyticsByRole,
  getPreventiveActionAnalyticsListByRole,
  getAccusedListWithTwoOrMoreListByRole,
  getAccusedListWithTwoOrMoreListIdByRole,
  getAccusedListWithTwoOrMoreCountDistinctByRole,
  getAccusedListWithTwoOrMoreCountIdByRole,
};
const baseUrl = config.apiGateway.baseUrl;
function OngoingPreventiveActionListByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/OngoingPreventiveActionListByRole/`,
    requestOptions,
  );
}
function CompletedPreventiveActionListByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/CompletedPreventiveActionListByRole/`,
    requestOptions,
  );
}
function getPreventiveListByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getPreventiveListByRole/`, requestOptions);
}

function getPreventiveCountByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getPreventiveCountByRole/`, requestOptions);
}
function getOngoingPreventiveActionCountByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getOngoingPreventiveActionCountByRole/`,
    requestOptions,
  );
}
function getCompletedPreventiveActionCountByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getCompletedPreventiveActionCountByRole/`,
    requestOptions,
  );
}
function getAllCountByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getAllCountsByRole/`, requestOptions);
}
function getStatisticalReport(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getStatisticalReport/`, requestOptions);
}
function TotalAppUsersCountByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/TotalAppUsersCountByRole/`, requestOptions);
}

function getArrestReportByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getArrestReportByRole/`, requestOptions);
}
function getReportSpotviseByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getReportSpotviseByRole/`, requestOptions);
}
function getGpsinformationByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getGpsinformationByRole/`, requestOptions);
}
function getQrInformationByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getQrInformationByRole/`, requestOptions);
}
function getCriminalsTableInfoByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getCriminalsTableInfoByRole/`,
    requestOptions,
  );
}

function getCriminalsAppInfoSearchByrole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getCriminalsAppInfoSearchByrole/`,
    requestOptions,
  );
}
function getGunaHeadingArophiFilterByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getGunaHeadingArophiFilterByRole/`,
    requestOptions,
  );
}
function getFilterCriminalsTableInfoByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getFilterCriminalsTableInfoByRole/`,
    requestOptions,
  );
}
function gunaYearWiseByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/gunaYearWiseByRole/`, requestOptions);
}
function getCriminalsHeadingFilterByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getCriminalsHeadingFilterByRole/`,
    requestOptions,
  );
}

function totaltwoplusCountByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/totaltwoplusCountByRole/`, requestOptions);
}
function preventionActionCountByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/preventionActionCountByRole/`,
    requestOptions,
  );
}
function surveillanceCountByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/surveillanceCountByRole/`, requestOptions);
}
function totalappuserCountByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/totalappuserCountByRole/`, requestOptions);
}

function filledPoliceStationDailyByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getTwoPlusAccusedByStationGraphByRole/`,
    requestOptions,
  );
}
function notFilledPoliceStationDailyByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getTwoPlusCrimeAccusedByStationGraphByRole/`,
    requestOptions,
  );
}
function getWantedCountByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getWantedCountByRole`, requestOptions);
}
function getConditionWantedByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getConditionWantedByRole`, requestOptions);
}
function getTadipaarCountByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getTadipaarCountByRole`, requestOptions);
}
function getTadipaarByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getTadipaarByRole`, requestOptions);
}
function getListGunaReportByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getListGunaReportByRole`, requestOptions);
}
function getCountGunaReportByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getCountGunaReportByRole`, requestOptions);
}
function gunaFilterDropDownByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/gunaFilterDropDownByRole`, requestOptions);
}
function noticeCountByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/noticeCountByRole`, requestOptions);
}

function noticeListByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/noticeListByRole`, requestOptions);
}
function getArrestCountByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getArrestCountByRole`, requestOptions);
}
function noticeGraphByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/noticeGraphByRole`, requestOptions);
}
function arrestGraphByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/arrestGraphByRole`, requestOptions);
}
function gunaGraphByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/gunaGraphByRole`, requestOptions);
}
function getPreventiveActionAnalyticsByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getPreventiveActionAnalyticsByRole`,
    requestOptions,
  ).then(handleResponse);
}
function getPreventiveActionAnalyticsListByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getPreventiveActionAnalyticsListByRole`,
    requestOptions,
  ).then(handleResponse);
}
function getAccusedListWithTwoOrMoreListByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getAccusedListWithTwoOrMoreListByRole`,
    requestOptions,
  ).then(handleResponse);
}
function getAccusedListWithTwoOrMoreListIdByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getAccusedListWithTwoOrMoreListIdByRole`,
    requestOptions,
  ).then(handleResponse);
}

function getAccusedListWithTwoOrMoreCountDistinctByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getAccusedListWithTwoOrMoreCountDistinctByRole`,
    requestOptions,
  ).then(handleResponse);
}

function getAccusedListWithTwoOrMoreCountIdByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getAccusedListWithTwoOrMoreCountIdByRole`,
    requestOptions,
  ).then(handleResponse);
}
